import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../MemberDashboard.css";
import { apiGet } from "../../../DataService/apiClient";
import { Course, CourseProgressViewDto } from "../../../Types/CourseTypes";
import { UserCourseListItem } from "../../../Types/UserCourseTypes";

export const DashboardResources = () => {
  const navigate = useNavigate();

  const [course, setCourse] = useState<Course | null>(null);
  const [progress, setProgress] = useState<CourseProgressViewDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadResources();
  }, []);

  const loadResources = async () => {

    try {
      const courses = await apiGet<UserCourseListItem[]>("/UserCourse/my-courses");
      const membershipCourse = (courses ?? [])
        .filter(item => String(item.accessType ?? "").toLowerCase() === "membership")
        .sort((a, b) => {
          const aDate = a.accessExpiresAt ? new Date(a.accessExpiresAt).getTime() : 0;
          const bDate = b.accessExpiresAt ? new Date(b.accessExpiresAt).getTime() : 0;
          return bDate - aDate;
        })[0];

      if (!membershipCourse) {
        setCourse(null);
        setProgress(null);
        return;
      }

      const [courseData, progressData] = await Promise.all([
        apiGet<Course>(`/courses/${membershipCourse.courseId}/user`),
        apiGet<CourseProgressViewDto>(`/UserCourse/${membershipCourse.courseId}/progress`)
      ]);

      setCourse(courseData ?? null);
      setProgress(progressData ?? null);

    } catch (err) {
      console.error("Resource load error", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-section">
        <p>Laddar material...</p>
      </div>
    );
  }

  const chapters = (progress?.chapters ?? [])
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(chapter => {
      const courseChapter = course?.chapters.find(c => c.id === chapter.chapterId);
      const contents = courseChapter?.contents ?? [];

      return {
        ...chapter,
        title: courseChapter?.title ?? chapter.title,
        contents
      };
    });

  return (
    <div className="dashboard-section">
      <div className="dashboard-header">
        <h1>Material</h1>
        <p>Här finns materialet som hör till din aktiva resa och det som redan har släppts.</p>
      </div>

      {!course && (
        <div className="dashboard-empty">
          <p>Inget aktivt material just nu.</p>
        </div>
      )}

      {course && (
        <>
          <div className="dashboard-card">
            <p className="dashboard-callout-kicker">Aktivt material</p>
            <h3>{course.title}</h3>
            <p>{course.description}</p>
            <button type="button" className="dashboard-course-inline-cta" onClick={() => navigate(`/member/courses/${course.id}`)}>
              Öppna kursen
            </button>
          </div>

          <div className="dashboard-resources">
            {chapters.length === 0 ? (
              <div className="dashboard-empty">
                <p>Inget innehåll är upplagt ännu.</p>
              </div>
            ) : (
              chapters.map(chapter => (
                <div key={chapter.chapterId} className="dashboard-resource-card">
                  <div className="dashboard-resource-info">
                    <h4>{chapter.title}</h4>
                    <span className="dashboard-resource-meta">
                      Modul {chapter.sortOrder} • {chapter.isUnlocked ? "Tillgänglig" : `Låses upp ${new Date(chapter.unlockDate).toLocaleDateString()}`}
                    </span>
                    <span className="dashboard-resource-meta">
                      {chapter.contents.length} innehållsdelar
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}

    </div>
  );
};
